import * as React from 'react';
import { connect } from 'react-redux';
import { TouchableOpacity, FlatList, ScrollView, LayoutAnimation, StyleSheet } from 'react-native';

import { Container, Header, InputGroup, Content, Text, H2, H3, Label, List, ListItem, Picker, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title } from 'native-base';

import { Field, reduxForm, change, FieldArray, arrayRemove, arrayInsert } from 'redux-form';

import diff from 'object-diff';
import XDate from 'xdate';
import CalCalDataApi from '../../api/CalCalDataApi';
import { SwipeListView } from 'react-native-swipe-list-view';
import AccountsForm from '../../forms/busDetails.accounts';
import Modal from '../../components/modal';

const accountIcons = { cash: 'cash', current: 'card', credit: 'card', savings: 'wallet', loan: 'paper' };

class Accounts extends React.Component {
	constructor(props) {
		super(props);
		//assuming props!

		this.initialState = { editItem: null };

		this.state = this.initialState;
	}

	//need to do something before unload... user has dismissed modal and will expect to save???

	accountsSubmit(values) {
		//actually submits then fires dispatch to update appropriate store
		//diff values with this.props.busDetails or whatever
		let difference = diff(this.state.editItem, values); //added, deleted, changed, updated (arrays)
		if (!difference || Object.keys(difference).length == 0) return false;
		__DEV__ && console.log('SUBITTing', difference);
		return CalCalDataApi.dataUpdate('accounts/' + values.id, difference, this.props.jwt, res => {
			//console.log('handleSubmit ', res);
			if (res.success) {
				this.props.dispatch({
					type: 'UPDATE/account', //successful update send UPDATE(d) to store
					difference, //IF no JSON returned, trust local changes
					id: values.id
				});
				return false;
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
				throw new SubmissionError(res.validationErrors);
			}
		});
	}

	async formBack() {
		if (!this.refs.form) return;
		let errors = await this.refs.form.submit();
		this.setState({ editItem: null });
		if (!errors) {
			this.setState({ isModalVisible: false });
		} else {
			return errors;
		}
	}

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val);
		this.props.dispatch(change('BusDetails.Accounts', field, val));
	}

	deleteRow(rowId, rowMap, key) {
		//_.filter(rows, row);
		console.log('delete ', rowId);
		this.closeRow(rowMap, key);

		//this.props.dispatch(arrayRemove('BusDetails.Accounts', 'items', rowId));
		//this._changeFormVal('items', [...this.state.itemArray, item])
	}

	copyRow(row, item) {
		//console.log(arrayInsert('BusDetails.Accounts', 'items', row, item));
		//this.props.dispatch(arrayInsert('BusDetails.Accounts', 'items', row, item));
	}

	closeRow(rowMap, rowKey) {
		__DEV__ && console.log(arguments);
		if (rowMap[rowKey]) {
			rowMap[rowKey].closeRow();
		}
	}

	_renderItem({ item, index }, rowMap) {
		//console.log(arguments);
		return (
			<ListItem
				key={index}
				style={{ flexDirection: 'column', backgroundColor: '#FFF', paddingLeft: 0, marginLeft: 0, alignItems: 'stretch' }}
				onPress={() => {
					LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
					this.setState({ editItem: item });
				}}>
				<View style={{ flexDirection: 'row', marginLeft: 10 }}>
					<Icon name={accountIcons[item.type]} style={{ color: 'grey' }} />
					<Text style={{ textAlign: 'left', marginLeft: 25 }}>{item.nickName}</Text>
					<Text note style={{ textAlign: 'right', flex: 1 }}>
						{item.description}
					</Text>
				</View>
				<View style={{ flexDirection: 'row', marginLeft: 10 }}>
					<Text style={{ flex: 1, color: '#999', fontSize: 9 }}>{item.type.toUpperCase()}</Text>
					<Text note>Balance set at £{item.openingBalance}</Text>
					<Text note> on {item.openingBalanceDate && new XDate(item.openingBalanceDate).toString('dd/MM/yy')}</Text>
				</View>
			</ListItem>
		);
	}
	/*
	_renderItems = (accounts, rowMap) => (
		<List
			dataSource={this.ds.cloneWithRows(accounts)}
			renderRow={this._renderItem.bind(this)}
			renderRightHiddenRow={(data, secId, rowId, rowMap) => (
				<Button full onPress={_ => this.copyRow(secId, rowId, rowMap, data)}>
					<Icon active name="copy" />
				</Button>
			)}
			renderLeftHiddenRow={(data, secId, rowId, rowMap) => (
				<Button full danger onPress={_ => this.deleteRow(secId, rowId, rowMap)}>
					<Icon active name="trash" />
				</Button>
			)}
			leftOpenValue={75}
			rightOpenValue={-75}
			closeOnRowBeginSwipe
		/>
	);*/

	render() {
		const { editItem } = this.state;
		const { accounts, close, show } = this.props;
		//list accounts. onPress one sets editingItem; this shows form.
		//Form onSubmit is handled here
		if (!accounts) return <Spinner />;

		accounts.forEach(acc => (acc.key = acc.id));
		//this.ds = new ListView.DataSource({ rowHasChanged: (r1, r2) => r1 !== r2 });
		return (
			<Modal
				isOpen={show}
				backButtonClose
				coverScreen
				swipeThreshold={100}
				//onClosingState={closing => this.onClosing(closing)}
				onClosed={() => close()}
				style={styles.modalStyle}
				//backdropOpacity={0.7}
				useNativeDriver>
				<Header style={styles.modalHeader}>
					<Body>
						<Title>Accounts</Title>
					</Body>
					<Right>
						<Button transparent onPress={close}>
							<Icon name={'arrow-down'} />
						</Button>
					</Right>
				</Header>
				<Content style={{ backgroundColor: 'white', minHeight: 500 }}>
					{this.state.isModalSaving && <Spinner />}
					{!!editItem ? (
						<AccountsForm
							initialValues={editItem}
							accountTypes={this.props.accountTypes}
							onSubmit={this.accountsSubmit.bind(this)}
							onBack={() => this.formBack()}
							onCancel={() => this.setState({ editItem: null })}
							ref="form"
						/>
					) : (
						<SwipeListView
							data={accounts}
							renderItem={this._renderItem.bind(this)}
							leftOpenValue={55}
							rightOpenValue={-55}
							renderHiddenItem={(data, rowMap, b) => (
								<View style={styles.rowBack}>
									<Button
										style={styles.hiddenBtn}
										onPress={() => {
											this.closeRow(rowMap, data.item.key);
											this.copyRow(data.index, data.item);
										}}>
										<Icon active name="copy" />
									</Button>
									<Button danger style={styles.hiddenBtn} onPress={_ => this.deleteRow(data.index, rowMap, data.item.key)}>
										<Icon name="trash" />
									</Button>
								</View>
							)}
						/>
					)}
				</Content>
			</Modal>
		);
	}
}

const styles = StyleSheet.create({
	rowBack: {
		alignItems: 'center',
		backgroundColor: '#DDD',
		flex: 1,
		height: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between'
		//paddingLeft: 15
	},
	hiddenBtn: {
		width: 55,
		height: '100%'
	},
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		height: 'auto',
		maxHeight: '90%'
	},
	modalContainer: {
		//width: '100%',
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: 'rgba(255,255,255,0)' //'#f8f8fc'
	},

	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},

	bottomBtns: {
		backgroundColor: '#295670',
		flexDirection: 'row'
	}
});

const mapStateToProps = state => ({
	accounts: state.globalReducer.accounts,
	accountTypes: state.globalReducer.accountTypes,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});
export default connect(mapStateToProps)(Accounts);
